import {Section} from "./section/Section"
import {Location} from "./section/location/Location";
import {Assistant} from "./section/assistant/Assistant";
import {Navigation} from "./section/navigation/Navigation";
import {Container} from "../helpers/container/Container";

export const Footer = () => {
    return (
        <footer>
            <Container>
                <div className="footer__grid">
                    <Section title="Ubicaciones" icon="cil:location-pin">
                        <Location
                            title="Zona Oeste"
                            address="Av. Julio Argentino Roca 1818 - Trujui (Moreno) - Buenos Aires"
                            mobile="11-6014-0192"
                            link="https://maps.app.goo.gl/ncHZQTEYYmtE46359"
                        />
                        <Location
                            title="Zona Oeste"
                            address="Parque Industrial Franco del Oeste - Trujui (Moreno) - Buenos Aires"
                            link="https://maps.app.goo.gl/y4RS2UQQ6sBFLf5H9"
                        />
                    </Section>
                    <Section title="Asistencia" icon="ep:service">
                        <Assistant
                            title="Asistencia postventa"
                            speech="Si necesitas ayuda con tu piscina contactanos por WhatsApp tocando el siguiente contacto:"
                            whatsapp="11-7128-5234"
                            phone="5491171285234"
                        />
                    </Section>
                    <Section title="Web" icon="fluent:desktop-24-regular">
                        <Navigation />
                    </Section>
                </div>
            </Container>
        </footer>
    )
}